import { Spinner } from '@/components/ui/spinner'
import type { Component } from 'solid-js'
import { css } from 'styled-system/css'

export const Loading: Component<{ fill?: boolean }> = (props) => {
  return (
    <div
      class={css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        background: props.fill ? 'bg.default' : 'none',
      })}
    >
      <Spinner />
    </div>
  )
}
